import _ from 'underscore';

const simpleOperatorMap = {
  $eq: 'eq',
  $ne: 'neq',
  $neq: 'neq',
  $gt: 'gt',
  $ge: 'gte',
  $gte: 'gte',
  $lt: 'lt',
  $le: 'lte',
  $lte: 'lte',
  $contains: 'contains',
  $doesnotcontain: 'doesnotcontain',
  $substringof: 'contains',
  $endswith: 'endswith',
  $startswith: 'startswith',
  $containsall: 'containsall',
  $containsany: 'containsany',
  $containsnone: 'containsnone',
  $isof: 'isof',
};
const logicOperatorMap = {
  $and: 'and',
  $or: 'or',
};

function simpleExpression(ignoreCase, field, operator, value) {
  const toLower = _.isString(value) &&
                  (ignoreCase === true || (_.isArray(ignoreCase) && _.contains(ignoreCase, field)));
  return {
    field: toLower ? `tolower(${field})` : field,
    value: toLower ? value.toLowerCase() : value,
    operator: simpleOperatorMap[operator],
  };
}

function convertEnumSelectionLeaf(ignoreCase, field, value, filterSchema) {
  return _.isArray(value) && value.length ?
    {
      logic: 'or',
      filters: _.map(value, val => simpleExpression(ignoreCase, field, '$eq', val, filterSchema)),
    } :
    null;
}

function convertLeaf({ fieldMap, ignoreCase }, fieldVal, expression, filterSchema) {
  const operator = _.keys(expression)[0];
  const value = _.values(expression)[0];
  const field = fieldMap[fieldVal] ? fieldMap[fieldVal] : fieldVal;

  if (operator === '$in') {
    return convertEnumSelectionLeaf(ignoreCase, field, value, filterSchema);
  }

  if (simpleOperatorMap[operator]) {
    return simpleExpression(ignoreCase, field, operator, value, filterSchema);
  }
  return null;
}

function convertNode(option, expressionKey, expression, filterSchema) {
  if (!_.isArray(expression)) {
    return convertLeaf(option, expressionKey, expression, filterSchema);
  }
  const logic = logicOperatorMap[expressionKey];
  return logic ?
    {
      logic,
      filters: _.chain(expression)
        .map(value => convertNode(option, _.keys(value)[0], _.values(value)[0], filterSchema))
        .filter(Boolean)
        .value(),
    } :
    null;
}

/**
 * Convert normalized filter object to kendo format with given options.
 * @param {Object} filters - normalized filter object to convert.
 * @param {Object} options - given options.
 * @param {Object} [options.fieldMap] - set of field aliases, if property names on clientside
 *                                      and server side are different. e.g. {'id' : 'AdGroupId'}
 * @param {boolean|string[]} [options.ignoreCase] - ignore case or not for field string.
 * @param {Object} filterSchema - filter schema.
 * @returns {Object} - kendo formatted filter object.
 */
export function convertToKendo(filters, { fieldMap, ignoreCase } = {}, filterSchema) {
  const kendoFilters = _.chain(filters)
    .map((value, key) => convertNode({ fieldMap, ignoreCase }, key, value, filterSchema))
    .filter(Boolean)
    .value();

  return !kendoFilters || _.isEmpty(kendoFilters) ? null : { filters: kendoFilters };
}
